export default __webpack_public_path__ + "static/media/HR@3x.f70eb2bc.png";